import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import common from './modules/common'
const getters = {
    loading: state => state.loading,
    runTimeInterval: state => state.runTimeInterval,
    notice: state => state.websiteInfo?state.websiteInfo.notice:''
}

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    common
  },
  getters
})

export default store

